import { useEffect, useState } from 'react'
import { useQuery } from 'react-query'
import { useChosenCompany } from '../../../../context/UserProvider'
import { fetchFleetReport, fetchFleetReportTerms } from '../../../../api/api'
import LeasingReportTable from '../components/LeasingReportTable'
import { ConsolidateInvoiceSelect } from '../../../cars/components/V3/_shared/ConsolidateInvoiceSelect'
import { useFilterOnConsolidateAgreement } from '../../hooks/useFilterOnConsolidateAgreement'
import { Select } from '../../../cars/components/V3/_shared/Select'
import type { Leasing } from '../../../../types'
import { ExcelExportButton } from '../components/ExcelExporter'
import { formatTerms } from '../../../../utils/helpers/helpers.reports'
import { leasingReportColumns } from '../components/LeasingReportTable/excelUtils'

const LeasingReport = () => {
  const company = useChosenCompany()
  const companyId = company?.id
  const [term, setTerm] = useState('')

  const { data: terms = [] } = useQuery(['fleetReportTerms', companyId], () => fetchFleetReportTerms(companyId), {
    enabled: !!companyId,
  }) as { data: string[] }

  const formattedTerms = formatTerms(terms)
  useEffect(() => {
    if (formattedTerms.length > 0 && term === '') {
      setTerm(formattedTerms[0].value)
    }
  }, [formattedTerms, term])

  const { data: response, status } = useQuery(
    ['fleetReport', companyId, term, 'leasing'],
    () => fetchFleetReport(companyId, term, 'leasing'),
    { enabled: !!companyId && !!term },
  )

  const data = (Array.isArray(response) ? response : response && 'data' in response ? response.data : []) as Leasing[]

  const agreementFilter = useFilterOnConsolidateAgreement()

  const filteredData = data
    .filter(agreementFilter('consolidatedAgreementID'))
    .filter((el) => el.termDate.startsWith(term))

  const config = {
    columns: leasingReportColumns(),
    filename: `Leasingrapport_${term}.xlsx`,
    sheetName: `Leasingrapport_${term}`,
  }

  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-col md:flex-row md:items-center gap-2 md:justify-between">
        <div className="flex flex-row justify-between items-center">
          <span className="text-xl font-medium text-primaryText">Leasingrapport</span>
          <div className="md:hidden">
            <ExcelExportButton data={filteredData} config={config} />
          </div>
        </div>
        <div className="flex flex-row gap-2 w-full md:w-auto">
          <div className="flex-1 md:flex-none">
            <Select
              className="h-11 w-full"
              placeholder={'Termin'}
              options={formattedTerms}
              value={term}
              onChange={setTerm}
            />
          </div>
          <div className="flex-1 md:flex-none">
            <ConsolidateInvoiceSelect className="h-11 w-full" />
          </div>
          <div className="hidden md:block">
            <ExcelExportButton data={filteredData} config={config} />
          </div>
        </div>
      </div>

      <LeasingReportTable isLoading={status === 'loading'} data={filteredData} />
    </div>
  )
}

export default LeasingReport
